export enum USWizardBillingProductIds {
  // Charges (One-time):
  DELAWARE_C_CORP_INCORPORATION = 'US---Delaware-C-Corp-Incorporation-2',
  DELAWARE_LLC_INCORPORATION = 'US---Delaware-LLC-Incorporation',
  DELAWARE_REGISTERED_AGENT = 'US---Delaware-Registered-Agent',
  ALABAMA_C_CORP_INCORPORATION = 'US---Alabama-C-Corp-Incorporation',
  ALABAMA_LLC_INCORPORATION = 'US---Alabama-LLC-Incorporation',
  ALABAMA_REGISTERED_AGENT = 'US---Alabama-Registered-Agent',
  ALASKA_C_CORP_INCORPORATION = 'US---Alaska-C-Corp-Incorporation',
  ALASKA_LLC_INCORPORATION = 'US---Alaska-LLC-Incorporation',
  ALASKA_REGISTERED_AGENT = 'US---Alaska-Registered-Agent',
  ARIZONA_C_CORP_INCORPORATION = 'US---Arizona-C-Corp-Incorporation',
  ARIZONA_LLC_INCORPORATION = 'US---Arizona-LLC-Incorporation',
  ARIZONA_REGISTERED_AGENT = 'US---Arizona-Registered-Agent',
  ARKANSAS_C_CORP_INCORPORATION = 'US---Arkansas-C-Corp-Incorporation',
  ARKANSAS_LLC_INCORPORATION = 'US---Arkansas-LLC-Incorporation',
  ARKANSAS_REGISTERED_AGENT = 'US---Arkansas-Registered-Agent',
  CALIFORNIA_C_CORP_INCORPORATION = 'US---California-C-Corp-Incorporation',
  CALIFORNIA_LLC_INCORPORATION = 'US---California-LLC-Incorporation',
  CALIFORNIA_REGISTERED_AGENT = 'US---California-Registered-Agent',
  COLORADO_C_CORP_INCORPORATION = 'US---Colorado-C-Corp-Incorporation',
  COLORADO_LLC_INCORPORATION = 'US---Colorado-LLC-Incorporation',
  COLORADO_REGISTERED_AGENT = 'US---Colorado-Registered-Agent',
  CONNECTICUT_C_CORP_INCORPORATION = 'US---Connecticut-C-Corp-Incorporation',
  CONNECTICUT_LLC_INCORPORATION = 'US---Connecticut-LLC-Incorporation',
  CONNECTICUT_REGISTERED_AGENT = 'US---Connecticut-Registered-Agent',
  FLORIDA_C_CORP_INCORPORATION = 'US---Florida-C-Corp-Incorporation',
  FLORIDA_LLC_INCORPORATION = 'US---Florida-LLC-Incorporation',
  FLORIDA_REGISTERED_AGENT = 'US---Florida-Registered-Agent',
  GEORGIA_C_CORP_INCORPORATION = 'US---Georgia-C-Corp-Incorporation',
  GEORGIA_LLC_INCORPORATION = 'US---Georgia-LLC-Incorporation',
  GEORGIA_REGISTERED_AGENT = 'US---Georgia-Registered-Agent',
  HAWAII_C_CORP_INCORPORATION = 'US---Hawaii-C-Corp-Incorporation',
  HAWAII_LLC_INCORPORATION = 'US---Hawaii-LLC-Incorporation',
  HAWAII_REGISTERED_AGENT = 'US---Hawaii-Registered-Agent',
  IDAHO_C_CORP_INCORPORATION = 'US---Idaho-C-Corp-Incorporation',
  IDAHO_LLC_INCORPORATION = 'US---Idaho-LLC-Incorporation',
  IDAHO_REGISTERED_AGENT = 'US---Idaho-Registered-Agent',
  ILLINOIS_C_CORP_INCORPORATION = 'US---Illinois-C-Corp-Incorporation',
  ILLINOIS_LLC_INCORPORATION = 'US---Illinois-LLC-Incorporation',
  ILLINOIS_REGISTERED_AGENT = 'US---Illinois-Registered-Agent',
  INDIANA_C_CORP_INCORPORATION = 'US---Indiana-C-Corp-Incorporation',
  INDIANA_LLC_INCORPORATION = 'US---Indiana-LLC-Incorporation',
  INDIANA_REGISTERED_AGENT = 'US---Indiana-Registered-Agent',
  IOWA_C_CORP_INCORPORATION = 'US---Iowa-C-Corp-Incorporation',
  IOWA_LLC_INCORPORATION = 'US---Iowa-LLC-Incorporation',
  IOWA_REGISTERED_AGENT = 'US---Iowa-Registered-Agent',
  KANSAS_C_CORP_INCORPORATION = 'US---Kansas-C-Corp-Incorporation',
  KANSAS_LLC_INCORPORATION = 'US---Kansas-LLC-Incorporation',
  KANSAS_REGISTERED_AGENT = 'US---Kansas-Registered-Agent',
  KENTUCKY_C_CORP_INCORPORATION = 'US---Kentucky-C-Corp-Incorporation',
  KENTUCKY_LLC_INCORPORATION = 'US---Kentucky-LLC-Incorporation',
  KENTUCKY_REGISTERED_AGENT = 'US---Kentucky-Registered-Agent',
  LOUISIANA_C_CORP_INCORPORATION = 'US---Louisiana-C-Corp-Incorporation',
  LOUISIANA_LLC_INCORPORATION = 'US---Louisiana-LLC-Incorporation',
  LOUISIANA_REGISTERED_AGENT = 'US---Louisiana-Registered-Agent',
  MAINE_C_CORP_INCORPORATION = 'US---Maine-C-Corp-Incorporation',
  MAINE_LLC_INCORPORATION = 'US---Maine-LLC-Incorporation',
  MAINE_REGISTERED_AGENT = 'US---Maine-Registered-Agent',
  MARYLAND_C_CORP_INCORPORATION = 'US---Maryland-C-Corp-Incorporation',
  MARYLAND_LLC_INCORPORATION = 'US---Maryland-LLC-Incorporation',
  MARYLAND_REGISTERED_AGENT = 'US---Maryland-Registered-Agent',
  MASSACHUSETTS_C_CORP_INCORPORATION = 'US---Massachusetts-C-Corp-Incorporation',
  MASSACHUSETTS_LLC_INCORPORATION = 'US---Massachusetts-LLC-Incorporation',
  MASSACHUSETTS_REGISTERED_AGENT = 'US---Massachusetts-Registered-Agent',
  MICHIGAN_C_CORP_INCORPORATION = 'US---Michigan-C-Corp-Incorporation',
  MICHIGAN_LLC_INCORPORATION = 'US---Michigan-LLC-Incorporation',
  MICHIGAN_REGISTERED_AGENT = 'US---Michigan-Registered-Agent',
  MINNESOTA_C_CORP_INCORPORATION = 'US---Minnesota-C-Corp-Incorporation',
  MINNESOTA_LLC_INCORPORATION = 'US---Minnesota-LLC-Incorporation',
  MINNESOTA_REGISTERED_AGENT = 'US---Minnesota-Registered-Agent',
  MISSISSIPPI_C_CORP_INCORPORATION = 'US---Mississippi-C-Corp-Incorporation',
  MISSISSIPPI_LLC_INCORPORATION = 'US---Mississippi-LLC-Incorporation',
  MISSISSIPPI_REGISTERED_AGENT = 'US---Mississippi-Registered-Agent',
  MISSOURI_C_CORP_INCORPORATION = 'US---Missouri-C-Corp-Incorporation',
  MISSOURI_LLC_INCORPORATION = 'US---Missouri-LLC-Incorporation',
  MISSOURI_REGISTERED_AGENT = 'US---Missouri-Registered-Agent',
  MONTANA_C_CORP_INCORPORATION = 'US---Montana-C-Corp-Incorporation',
  MONTANA_LLC_INCORPORATION = 'US---Montana-LLC-Incorporation',
  MONTANA_REGISTERED_AGENT = 'US---Montana-Registered-Agent',
  NEBRASKA_C_CORP_INCORPORATION = 'US---Nebraska-C-Corp-Incorporation',
  NEBRASKA_LLC_INCORPORATION = 'US---Nebraska-LLC-Incorporation',
  NEBRASKA_REGISTERED_AGENT = 'US---Nebraska-Registered-Agent',
  NEVADA_C_CORP_INCORPORATION = 'US---Nevada-C-Corp-Incorporation',
  NEVADA_LLC_INCORPORATION = 'US---Nevada-LLC-Incorporation',
  NEVADA_REGISTERED_AGENT = 'US---Nevada-Registered-Agent',
  NEW_HAMPSHIRE_C_CORP_INCORPORATION = 'US---New-Hampshire-C-Corp-Incorporation',
  NEW_HAMPSHIRE_LLC_INCORPORATION = 'US---New-Hampshire-LLC-Incorporation',
  NEW_HAMPSHIRE_REGISTERED_AGENT = 'US---New-Hampshire-Registered-Agent',
  NEW_JERSEY_C_CORP_INCORPORATION = 'US---New-Jersey-C-Corp-Incorporation',
  NEW_JERSEY_LLC_INCORPORATION = 'US---New-Jersey-LLC-Incorporation',
  NEW_JERSEY_REGISTERED_AGENT = 'US---New-Jersey-Registered-Agent',
  NEW_MEXICO_C_CORP_INCORPORATION = 'US---New-Mexico-C-Corp-Incorporation',
  NEW_MEXICO_LLC_INCORPORATION = 'US---New-Mexico-LLC-Incorporation',
  NEW_MEXICO_REGISTERED_AGENT = 'US---New-Mexico-Registered-Agent',
  NEW_YORK_C_CORP_INCORPORATION = 'US---New-York-C-Corp-Incorporation',
  NEW_YORK_LLC_INCORPORATION = 'US---New-York-LLC-Incorporation',
  NEW_YORK_REGISTERED_AGENT = 'US---New-York-Registered-Agent',
  NORTH_CAROLINA_C_CORP_INCORPORATION = 'US---North-Carolina-C-Corp-Incorporation',
  NORTH_CAROLINA_LLC_INCORPORATION = 'US---North-Carolina-LLC-Incorporation',
  NORTH_CAROLINA_REGISTERED_AGENT = 'US---North-Carolina-Registered-Agent',
  NORTH_DAKOTA_C_CORP_INCORPORATION = 'US---North-Dakota-C-Corp-Incorporation',
  NORTH_DAKOTA_LLC_INCORPORATION = 'US---North-Dakota-LLC-Incorporation',
  NORTH_DAKOTA_REGISTERED_AGENT = 'US---North-Dakota-Registered-Agent',
  OHIO_C_CORP_INCORPORATION = 'US---Ohio-C-Corp-Incorporation',
  OHIO_LLC_INCORPORATION = 'US---Ohio-LLC-Incorporation',
  OHIO_REGISTERED_AGENT = 'US---Ohio-Registered-Agent',
  OKLAHOMA_C_CORP_INCORPORATION = 'US---Oklahoma-C-Corp-Incorporation',
  OKLAHOMA_LLC_INCORPORATION = 'US---Oklahoma-LLC-Incorporation',
  OKLAHOMA_REGISTERED_AGENT = 'US---Oklahoma-Registered-Agent',
  OREGON_C_CORP_INCORPORATION = 'US---Oregon-C-Corp-Incorporation',
  OREGON_LLC_INCORPORATION = 'US---Oregon-LLC-Incorporation',
  OREGON_REGISTERED_AGENT = 'US---Oregon-Registered-Agent',
  PENNSYLVANIA_C_CORP_INCORPORATION = 'US---Pennsylvania-C-Corp-Incorporation',
  PENNSYLVANIA_LLC_INCORPORATION = 'US---Pennsylvania-LLC-Incorporation',
  PENNSYLVANIA_REGISTERED_AGENT = 'US---Pennsylvania-Registered-Agent',
  RHODE_ISLAND_C_CORP_INCORPORATION = 'US---Rhode-Island-C-Corp-Incorporation',
  RHODE_ISLAND_LLC_INCORPORATION = 'US---Rhode-Island-LLC-Incorporation',
  RHODE_ISLAND_REGISTERED_AGENT = 'US---Rhode-Island-Registered-Agent',
  SOUTH_CAROLINA_C_CORP_INCORPORATION = 'US---South-Carolina-C-Corp-Incorporation',
  SOUTH_CAROLINA_LLC_INCORPORATION = 'US---South-Carolina-LLC-Incorporation',
  SOUTH_CAROLINA_REGISTERED_AGENT = 'US---South-Carolina-Registered-Agent',
  SOUTH_DAKOTA_C_CORP_INCORPORATION = 'US---South-Dakota-C-Corp-Incorporation',
  SOUTH_DAKOTA_LLC_INCORPORATION = 'US---South-Dakota-LLC-Incorporation',
  SOUTH_DAKOTA_REGISTERED_AGENT = 'US---South-Dakota-Registered-Agent',
  TENNESSEE_C_CORP_INCORPORATION = 'US---Tennessee-C-Corp-Incorporation',
  TENNESSEE_LLC_INCORPORATION = 'US---Tennessee-LLC-Incorporation',
  TENNESSEE_REGISTERED_AGENT = 'US---Tennessee-Registered-Agent',
  TEXAS_C_CORP_INCORPORATION = 'US---Texas-C-Corp-Incorporation',
  TEXAS_LLC_INCORPORATION = 'US---Texas-LLC-Incorporation',
  TEXAS_REGISTERED_AGENT = 'US---Texas-Registered-Agent',
  UTAH_C_CORP_INCORPORATION = 'US---Utah-C-Corp-Incorporation',
  UTAH_LLC_INCORPORATION = 'US---Utah-LLC-Incorporation',
  UTAH_REGISTERED_AGENT = 'US---Utah-Registered-Agent',
  VERMONT_C_CORP_INCORPORATION = 'US---Vermont-C-Corp-Incorporation',
  VERMONT_LLC_INCORPORATION = 'US---Vermont-LLC-Incorporation',
  VERMONT_REGISTERED_AGENT = 'US---Vermont-Registered-Agent',
  VIRGINIA_C_CORP_INCORPORATION = 'US---Virginia-C-Corp-Incorporation',
  VIRGINIA_LLC_INCORPORATION = 'US---Virginia-LLC-Incorporation',
  VIRGINIA_REGISTERED_AGENT = 'US---Virginia-Registered-Agent',
  WASHINGTON_C_CORP_INCORPORATION = 'US---Washington-C-Corp-Incorporation',
  WASHINGTON_LLC_INCORPORATION = 'US---Washington-LLC-Incorporation',
  WASHINGTON_REGISTERED_AGENT = 'US---Washington-Registered-Agent',
  WEST_VIRGINIA_C_CORP_INCORPORATION = 'US---West-Virginia-C-Corp-Incorporation',
  WEST_VIRGINIA_LLC_INCORPORATION = 'US---West-Virginia-LLC-Incorporation',
  WEST_VIRGINIA_REGISTERED_AGENT = 'US---West-Virginia-Registered-Agent',
  WISCONSIN_C_CORP_INCORPORATION = 'US---Wisconsin-C-Corp-Incorporation',
  WISCONSIN_LLC_INCORPORATION = 'US---Wisconsin-LLC-Incorporation',
  WISCONSIN_REGISTERED_AGENT = 'US---Wisconsin-Registered-Agent',
  WYOMING_C_CORP_INCORPORATION = 'US---Wyoming-C-Corp-Incorporation',
  WYOMING_LLC_INCORPORATION = 'US---Wyoming-LLC-Incorporation',
  WYOMING_REGISTERED_AGENT = 'US---Wyoming-Registered-Agent',
  // TODO(yaacov): Add other incorporation states:
  US_VIRTUAL_ADDRESS_SERVICE = 'US---Virtual-Address',
  // Filing that's bundled along with the entity setup:
  BENEFICIAL_OWNERSHIP_INFORMATION = 'US---Beneficial-Ownership-Information-Filing',
  // Add-ons (recurring):
  US_COMPLIANCE = 'US-Compliance',
  US_BOOKKEEPING = 'US-Bookkeeping',
  US_COMPLIANCE_PACKAGE = 'US-C-Corp-Compliance',
}
